import { IconAlarm, IconCircleCheck, IconClock } from '@tabler/icons-react'

import { PillProps } from '@/components/shared-components/BUI/Pill'

import { buildPassTheme } from 'src/styles/theme'

export const ticketStatuses = {
  expired: {
    text: 'Expired',
    label: 'Expired',
    color: buildPassTheme.colour.semantic.error,
    variant: 'danger' as PillProps['variant'],
    icon: <IconAlarm size={16} />,
  },
  expiringSoon: {
    text: 'Expiring Soon',
    label: 'Expiring Soon',
    color: buildPassTheme.colour.semantic.warning,
    variant: 'warning' as PillProps['variant'],
    icon: <IconClock size={16} />,
  },
  current: {
    text: 'Current',
    label: 'Current',
    color: buildPassTheme.colour.primary.base,
    variant: 'success' as PillProps['variant'],
    icon: <IconCircleCheck size={16} />,
  },
}

export const getTicketStatus = (dateString) => {
  if (!dateString) {
    return ticketStatuses.current
  }

  const now = new Date()
  const date = new Date(dateString)

  if (now > date) {
    return ticketStatuses.expired
  }

  const dateMinusMonth = new Date(dateString)
  dateMinusMonth.setMonth(date.getMonth() - 1)

  if (now > dateMinusMonth) {
    return ticketStatuses.expiringSoon
  }

  return ticketStatuses.current
}
